import { LoadCascadeCommand } from "slotworks/commands/comms/load-cascade-command";
import Components from "slotworks/components/components";
import BetModel from "slotworks/model/bets/bet-model";
import GameState from "slotworks/model/game-state";
import SettingsModel from "slotworks/model/settings/settings-model";
import { Services } from "slotworks/services/services";
import { HoldSpinControl } from "slotworks/smart-ui/controls/spin/hold-spin-control";
import SmartUIFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import State from "slotworks/state-machine/states/state";
import Contract from "slotworks/utils/contracts/contract";

export default class RequestCascade extends State {

    private skipping: boolean;

    public onEnter(cascadeSkip?: boolean) {

        this.skipping = cascadeSkip;

        if (this.skipping) {
            SmartUIFlags.set(SmartUIFlag.NO_SKIP, true);
        }

        SmartUIFlags.set(SmartUIFlag.AWAITING_RESPONSE, true);

        this.startCascade().then(() => {
            if (!GameState.getCurrentGame().getCurrentRecord()) {
                this.error();
            } else {
                GameState.getCurrentGame().totalStake = BetModel.getTotalStake();
                if (this.skipping) {
                    this.skip();
                } else {
                    this.complete();
                }
            }
        });
    }

    public error() {
        Components.matrix.reset();
        Services.autoplay.stop();
        HoldSpinControl.cancel();
        SettingsModel.setTurboSpin(false);

        super.error();
    }

    public onSkip() {
        SmartUIFlags.set(SmartUIFlag.NO_SKIP, true);
        this.skipping = true;
    }

    public onExit() {
        SmartUIFlags.set(SmartUIFlag.AWAITING_RESPONSE, false);
        SmartUIFlags.set(SmartUIFlag.NO_SKIP, false);
    }

    protected startCascade(): Contract<any> {
        return LoadCascadeCommand();
    }
}
